import { reactQueryPut } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { gamificationSettingsQueries } from "@circle-react/lib/queries/gamificationSettings";
import { useMutation, useQuery } from "react-query";
import type { UseMutationOptions } from "react-query";

import type { ApiError } from "@/react/config/CustomErrors";

export const useGamificationSettings = () =>
  useQuery(gamificationSettingsQueries.settings());

export const useUpdateGamificationSettingsMutation = (
  options?: UseMutationOptions<unknown, ApiError, any>,
) =>
  useMutation<unknown, ApiError, any>({
    mutationFn: data =>
      reactQueryPut(internalApi.gamification.settings(), data),
    ...options,
  });
